/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsMachineSubscription
 */
export interface MelcoModelsMachineSubscription {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsMachineSubscription
     */
    id?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MelcoModelsMachineSubscription
     */
    expiration_date?: Date | null;
}

export function MelcoModelsMachineSubscriptionFromJSON(json: any): MelcoModelsMachineSubscription {
    return MelcoModelsMachineSubscriptionFromJSONTyped(json, false);
}

export function MelcoModelsMachineSubscriptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsMachineSubscription {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'expiration_date': !exists(json, 'expiration_date') ? undefined : (json['expiration_date'] === null ? null : new Date(json['expiration_date'])),
    };
}

export function MelcoModelsMachineSubscriptionToJSON(value?: MelcoModelsMachineSubscription | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'expiration_date': value.expiration_date === undefined ? undefined : (value.expiration_date === null ? null : value.expiration_date.toISOString()),
    };
}


